import React, { useState, useEffect } from "react";
import DataGrid, {
  Column,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Selection,
  Scrolling,
  Summary,
  TotalItem,
  Format,
  Export,
  LoadPanel,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnChooserSelection,
  Position,
  Pager,
  Paging,
} from "devextreme-react/data-grid";
import DateBox from "devextreme-react/date-box";
import Select from "react-select";
import Grid from "@material-ui/core/Grid";
import { api_path } from "../../shared.js";
import Box from "@mui/material/Box";
import { createStore } from "devextreme-aspnet-data-nojquery";
export default function SalesReportComponent({ userId }) {
  const [getTeam, setTeam] = useState([]);
  const [getJobClass, setJobClass] = useState([]);
  const [getJobType, setJobType] = useState([]);
  const [getSelectTeam, setSelectTeam] = useState([]);
  const now = new Date();
  const dateLabel = { "aria-label": "Date" };
  var date = new Date();
  var firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
  var lastDay = new Date(date.getFullYear(), date.getMonth(), 0);
  const formattedfirstDay = firstDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");

  const formattedlastDay = lastDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");

  const [getDateFrom, setDateFrom] = useState(formattedfirstDay);
  const [getDateTo, setDateTo] = useState(formattedlastDay);
  const [getMinDate, setMinDate] = useState(null);
  const onValueChangedDateFrom = React.useCallback((e) => {
    const dateFrom = new Date(e.value);
    const formattedDateFrom = dateFrom
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateFrom(formattedDateFrom);
    setMinDate(formattedDateFrom);
  }, []);
  const onValueChangedDateTo = React.useCallback((e) => {
    const dateTo = new Date(e.value);
    const formattedDateTo = dateTo
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateTo(formattedDateTo);
  }, []);
  const teamList = [
    { value: "", label: "All" },
    { value: "SF,EX", label: "Sea Export" },
    { value: "SF,IM", label: "Sea Import" },
    { value: "AF,EX", label: "Air Export" },
    { value: "AF,IM", label: "Air Import" },
  ];
  const handleTeamChange = (selectedOption) => {
    const selectedValue = selectedOption?.value || "";

    if (selectedValue) {
      const [jobType, jobClass] = selectedValue.split(",");
      setJobType(jobType);
      setJobClass(jobClass);
    } else {
      setJobType("");
      setJobClass("");
    }
  };
  const [modeSize] = useState("widget");
  const columnChooserModes = [
    {
      key: "dragAndDrop",
      name: "Drag and drop",
    },
    {
      key: "select",
      name: "Select",
    },
  ];
  const searchEditorOptions = { placeholder: "Search column" };
  const pageSizes = [25, 50, 100];
  //Column Chooserb
  const [mode, setMode] = React.useState(columnChooserModes[1].key);
  const [searchEnabled, setSearchEnabled] = React.useState(true);
  const [allowSelectAll, setAllowSelectAll] = React.useState(true);
  const [selectByClick, setSelectByClick] = React.useState(true);
  const [recursive, setRecursive] = React.useState(true);
  const isDragMode = mode === columnChooserModes[0].key;
  const url = `${api_path}/customer/get-RevenueBySales.php?userId=${userId}&CRM_CUSCODE=0&get10=1&jobType=${getJobType}&jobClass=${getJobClass}&dateFrom=${getDateFrom}&dateTo=${getDateTo}`;

  const dataSource = createStore({
    key: "JOBNO",
    loadUrl: `${url}`,
  });
  const cellPrepared = (e) => {
    if (e.rowType === "data") {
      if (e.column.dataField === "ACTIVITY_NAME") {
        e.cellElement.innerHTML =
          "<span class='status-button activity-topic activity-" +
          e.data.ACTIVITY_NAME.toLowerCase().replace(/\s/g, "-") +
          "'><a href='Customer?customer_id=" +
          e.row.data.CRM_CUSCODE +
          "'  title='View' target='_blank' style='color: #FFFFFF;'>" +
          e.data.ACTIVITY_NAME +
          "</a></span>";
      }
      if (e.column.dataField === "CUSTOMER_NAME") {
        e.cellElement.innerHTML =
          "<span><a href='Customer?customer_id=" +
          e.row.data.CRM_CUSCODE +
          "'  title='View' target='_blank' class='link'>" +
          e.data.CUSTOMER_NAME +
          "</a></span>";
      }
    }
  };

  return (
    <div className="p-4 bg-white shadow rounded-2xl">
      <h5 className="font-semibold mb-2">📈 Sales Report</h5>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={2}>
          <label>Date From</label>
          <DateBox
            styles={{
              menu: (provided) => ({ ...provided, zIndex: 9999 }),
            }}
            defaultValue={now}
            inputAttr={dateLabel}
            type="date"
            displayFormat="dd/MM/yyyy"
            value={getDateFrom}
            onValueChanged={onValueChangedDateFrom}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>To</label>
          <DateBox
            defaultValue={now}
            inputAttr={dateLabel}
            type="date"
            displayFormat="dd/MM/yyyy"
            value={getDateTo}
            min={getMinDate}
            onValueChanged={onValueChangedDateTo}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Select Job Type/Class</label>
          <Select
            className="multiselect1"
            placeholder="Select..."
            value={teamList.find((item) => item.value === getTeam)}
            options={teamList}
            onChange={handleTeamChange}
            getOptionLabel={(x) => x.label}
            getOptionValue={(x) => x.value}
          />
        </Grid>
        <Grid item xs={12} sm={6}></Grid>
      </Grid>
      <Box sx={{ maxHeight: 800, overflow: "auto" }}>
        <DataGrid
          onCellPrepared={cellPrepared}
          dataSource={dataSource}
          showBorders={true}
          showColumnLines={true} // ✅ แสดงเส้นระหว่าง column
          showRowLines={true} // ✅ แสดงเส้นระหว่าง row
          columnAutoWidth={true}
          rowAlternationEnabled={true}
          showScrollbar={true}
          keyExpr="JOBNO"
          showColumnHeaders={true} // ซ่อนหัวตาราง
          height={800}
        >
          <Scrolling
            rowRenderingMode="virtual"
            showScrollbar="always"
            useNative="false"
            scrollByThumb="true"
          ></Scrolling>
          <FilterRow visible={true} />
          <FilterPanel visible={false} />
          <HeaderFilter visible={true} />
          <Selection mode="single" />
          <Column dataField="JOBCLASS" visible={false} />
          <Column dataField="JOBGROUP" caption="BU" width={50} />
          <Column dataField="JOBNO" allowHiding={false} />
          <Column dataField="BOOKNO" allowHiding={false} />
          <Column dataField="JobAdd" visible={false} />
          <Column dataField="JOBOWNER" caption="Job Owner" visible={false} />
          <Column dataField="CHGTERM" visible={false} />
          <Column
            dataField="ETD"
            caption="ETD"
            dataType="date"
            format="dd-MMM-yyyy"
            groupInterval="day"
          ></Column>
          <Column
            dataField="ETA"
            caption="ETA"
            dataType="date"
            format="dd-MMM-yyyy"
            groupInterval="day"
          ></Column>
          <Column dataField="TRADE" />
          <Column dataField="CARRIER" />
          <Column dataField="LANE" />
          <Column dataField="RECPORT" caption="POR" />
          <Column dataField="LOADPORT" caption="POL" />
          <Column dataField="DISPORT" caption="POD" />
          <Column dataField="DELPORT" caption="DEL" />
          <Column dataField="SHIPPERNAME" caption="SHIPPER" />
          <Column dataField="EXPORTERNAME" caption="EXPORTER" />
          <Column dataField="AGENTNAME" caption="AGENT" />
          <Column dataField="CONSIGNEE" caption="CNEE" />
          <Column
            dataField="GW"
            dataType="number"
            alignment="right" // ให้ค่าชิดขวา
            headerCellRender={() => (
              <div style={{ textAlign: "center", width: "100%" }}>GW</div>
            )}
          >
            <Format type="fixedPoint" precision={0} />
          </Column>
          <Column
            dataField="NW"
            dataType="number"
            alignment="right" // ให้ค่าชิดขวา
            headerCellRender={() => (
              <div style={{ textAlign: "center", width: "100%" }}>NW</div>
            )}
          >
            <Format type="fixedPoint" precision={0} />
          </Column>
          <Column
            dataField="CBM"
            dataType="number"
            alignment="right" // ให้ค่าชิดขวา
            headerCellRender={() => (
              <div style={{ textAlign: "center", width: "100%" }}>CBM</div>
            )}
          >
            <Format type="fixedPoint" precision={0} />
          </Column>
          <Column
            dataField="CTN20"
            alignment="right" // ให้ค่าชิดขวา
            headerCellRender={() => (
              <div style={{ textAlign: "center", width: "100%" }}>CTN20</div>
            )}
          ></Column>
          <Column
            dataField="CTN40"
            alignment="right" // ให้ค่าชิดขวา
            headerCellRender={() => (
              <div style={{ textAlign: "center", width: "100%" }}>CTN40</div>
            )}
          ></Column>
          <Column
            dataField="CTN40HC"
            alignment="right" // ให้ค่าชิดขวา
            headerCellRender={() => (
              <div style={{ textAlign: "center", width: "100%" }}>CTN40HC</div>
            )}
          ></Column>
          <Column
            dataField="CTN45"
            alignment="right" // ให้ค่าชิดขวา
            headerCellRender={() => (
              <div style={{ textAlign: "center", width: "100%" }}>CTN45</div>
            )}
          ></Column>
          <Column
            dataField="TOTTEU"
            alignment="right" // ให้ค่าชิดขวา
            headerCellRender={() => (
              <div style={{ textAlign: "center", width: "100%" }}>TOTTEU</div>
            )}
          ></Column>
          <Column
            dataField="REV"
            dataType="number"
            alignment="right"
            headerCellRender={() => (
              <div style={{ textAlign: "center", width: "100%" }}>Rev</div>
            )}
          >
            <Format type="fixedPoint" precision={0} />
          </Column>
          <Column
            dataField="COST"
            dataType="number"
            alignment="right"
            headerCellRender={() => (
              <div style={{ textAlign: "center", width: "100%" }}>Cost</div>
            )}
          >
            <Format type="fixedPoint" precision={0} />
          </Column>
          <Column
            dataField="THBAMT"
            dataType="number"
            alignment="right"
            headerCellRender={() => (
              <div style={{ textAlign: "center", width: "100%" }}>Profit</div>
            )}
          >
            <Format type="fixedPoint" precision={0} />
          </Column>
          <Column
            dataField="MARGIN"
            dataType="number"
            format={{ type: "percent", precision: 2 }}
            headerCellRender={() => (
              <div style={{ textAlign: "center", width: "100%" }}>Margin</div>
            )}
          ></Column>
          <Column dataField="CS" visible={false} />
          <Column
            dataField="HANDLEBYNAME"
            caption="Handle By"
            visible={false}
          />
          <ColumnChooser enabled={true} mode={mode}>
            <Position
              my="right top"
              at="right bottom"
              of=".dx-datagrid-column-chooser-button"
            />
            <ColumnChooserSearch
              enabled={searchEnabled}
              editorOptions={searchEditorOptions}
            />
            <ColumnChooserSelection
              allowSelectAll={allowSelectAll}
              selectByClick={selectByClick}
              recursive={recursive}
            />
          </ColumnChooser>
          <LoadPanel enabled={true} />
          <Export enabled={true} allowExportSelectedData={true} />
          <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
          <Paging defaultPageSize={25} />
          <Summary>
            <TotalItem
              column="REV"
              summaryType="sum"
              valueFormat={{ type: "fixedPoint", precision: 0 }} // รวมเป็น sum, มี comma
              displayFormat="Total: {0}"
            />
            <TotalItem
              column="COST"
              summaryType="sum"
              valueFormat={{ type: "fixedPoint", precision: 0 }}
              displayFormat="Total: {0}"
            />
            <TotalItem
              column="THBAMT"
              summaryType="sum"
              valueFormat={{ type: "fixedPoint", precision: 0 }}
              displayFormat="Total: {0}"
            />
             {/* <TotalItem
              column="MARGIN"
              summaryType="sum"
              valueFormat={{ type: "fixedPoint", precision: 0 }}
              displayFormat="Total: {0}"
            /> */}
          </Summary>
        </DataGrid>
      </Box>
    </div>
  );
}
